import { render, staticRenderFns } from "./SensitiveField.vue?vue&type=template&id=35c07bee&scoped=true"
import script from "./SensitiveField.vue?vue&type=script&lang=js"
export * from "./SensitiveField.vue?vue&type=script&lang=js"
import style0 from "./SensitiveField.vue?vue&type=style&index=0&id=35c07bee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c07bee",
  null
  
)

export default component.exports